
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-certified/cka-testimonies",
      function () {
        return require("private-next-pages/get-certified/cka-testimonies.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-certified/cka-testimonies"])
      });
    }
  